import { useState, useRef, useEffect } from 'react';
import { faqs } from '../data';

export default function FAQ() {
  const [openStates, setOpenStates] = useState(Array(faqs.length).fill(false));
  const contentRefs = useRef([]);

  const toggleFAQ = (index) => {
    setOpenStates((prev) => {
      const updated = [...prev];
      updated[index] = !updated[index];
      return updated;
    });
  };

  return (
    <section id="faq" className="py-16 bg-white scroll-mt-[120px]" data-aos="fade-up">
      <div className="max-w-3xl mx-auto">
        {/* Header + Description */}
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-900">
            Frequently Asked Questions
          </h2>
          <p className="mt-2 text-lg text-gray-600">
            Answers to common questions about our rental service
          </p>
        </div>

        {/* FAQ Items */}
        {faqs.map((item, idx) => (
          <div
            key={idx}
            className="border border-gray-200 rounded-lg overflow-hidden mb-4"
          >
            <button
              onClick={() => toggleFAQ(idx)}
              className="w-full flex justify-between items-center p-4 text-left font-medium text-gray-900 hover:bg-gray-50"
            >
              <span>{item.q}</span>
              {/* Inline SVG so rotation works reliably */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`w-5 h-5 transform transition-transform duration-300 ${
                  openStates[idx] ? 'rotate-180' : 'rotate-0'
                }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            {/* Animated expand/collapse with auto height */}
            <div
              ref={(el) => (contentRefs.current[idx] = el)}
              style={{
                maxHeight: openStates[idx]
                  ? `${contentRefs.current[idx]?.scrollHeight}px`
                  : '0px',
              }}
              className="overflow-hidden transition-all duration-300 ease-in-out"
            >
              <div className="p-4 text-gray-600 border-t border-gray-200">
                {item.a}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}